const moment = require("moment-timezone");

moment.locale("es");
moment.tz.setDefault("Europe/Madrid");

module.exports = moment;
